import React, { ReactElement, useCallback, useState } from 'react'
import { debounce } from 'lodash'

type Props = {
    label: string
    value: string
    configKey: string
    onChange: (configKey: string, newValue: string) => void
    handleTitleChange: (newValue: string) => void
    children?: unknown
    className?: string
}

export default function GroupTitleConfig(props: Props): ReactElement {
    const [value, setValue] = useState(props.value)
    const handleOnChange = (newValue: string): void => {
        setValue(newValue)
        props.handleTitleChange(newValue)
        onChange(newValue, props)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onChange = useCallback(
        debounce((x, p) => p.onChange(p.configKey, x), 1000),
        []
    )

    return (
        <div className="input-config" style={{ margin: '0 0 6px 0' }}>
            <label>{props.label}</label>
            <div className="input-field">
                <input
                    className={props.className}
                    type="text"
                    placeholder=""
                    value={value}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(e.target.value)}
                    style={{ boxShadow: 'none' }}
                />
                {props.children}
            </div>
        </div>
    )
}
